export namespace MoovyConstantNames {
  export const APP_FULLNAME = 'Helsinki-Vantaa drop-off'
  export const PHONE_FI_COUNTRY_CODE = '+358'
}

export namespace MoovyConstantDOMIds {
  export const MOOVY_BACKDROP_ANIMATION = 'moovy-backdrop-animation'
}
